import React, { useState } from 'react';
import { GraduationCap } from 'lucide-react';
import { User } from '../../../../models/auth';
import { WhatsappChatPanel } from '../../../components/WhatsappChat';
import AlumnosPracticasEditor from './AlumnosPracticasEditor';

interface AtencionPracticasPanelProps {
  user: User;
  apiUrl: string;
  apiKey: string;
}

// Chat de WhatsApp de accidentes de prácticas (servicio accidentepracticas):
// el panel compartido + horario de atención + lista de alumnos (específica de prácticas).
// Backend: acciones atencion_practicas_* (atencion_practicas.py)
const AtencionPracticasPanel: React.FC<AtencionPracticasPanelProps> = ({ user, apiUrl, apiKey }) => {
  const [showStudents, setShowStudents] = useState(false);

  return (
    <WhatsappChatPanel
      user={user}
      apiUrl={apiUrl}
      apiKey={apiKey}
      prefijo="atencion_practicas_"
      titulo="Conversaciones WhatsApp"
      conHorario
      accionesCabecera={
        <button type="button" className="ap-btn ap-btn-secondary" onClick={() => setShowStudents((prev) => !prev)}>
          <GraduationCap size={16} /> Lista de alumnos
        </button>
      }
      bajoCabecera={showStudents ? <AlumnosPracticasEditor user={user} apiUrl={apiUrl} apiKey={apiKey} /> : null}
    />
  );
};

export default AtencionPracticasPanel;
